import React, { useEffect, useState } from "react";
import { FetchFile } from "./FetchFile";

const PDF = ({ file }) => {
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    if (file) {
      FetchFile(file, setPdfUrl);
    }
  }, [file]);

  return (
    <>
      <div
        style={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <iframe
          src={pdfUrl}
          title="PDF Viewer"
          width="80%"
          height="80%"
          style={{ border: "none" }}
        />
      </div>
    </>
  );
};

export default PDF;
